import { useContext, useMemo } from 'react';
import { ApiContext } from '../contexts/ApiContext';
import { CATALOG_SECTIONS } from '../config/catalogSections';

const SIN_FILTRO = { productIds: null, brandSlugs: null };

/**
 * Qué equipos y marcas tiene sentido ofrecer en los selects de una sección.
 *
 * En /reparacion solo ~5% del catálogo tiene reparaciones cargadas, así que
 * ofrecer las 1755 opciones lleva a un cartel de "no hay soluciones" 19 de cada
 * 20 veces. Las marcas se derivan de los productos que quedaron: si a una marca
 * no le queda ninguno, tampoco se ofrece (elegirla dejaría el segundo select
 * vacío, que es peor que no verla).
 *
 * Devuelve null en ambos campos cuando no hay que filtrar (sección sin
 * requisito, o el dato todavía no llegó / el endpoint falló).
 */
export function useCatalogAvailability(section) {
    const { productSearch, serviceableProductIds } = useContext(ApiContext);
    const requires = CATALOG_SECTIONS[section]?.requires ?? null;

    return useMemo(() => {
        if (requires !== 'solutions') return SIN_FILTRO;
        if (!serviceableProductIds || !Array.isArray(productSearch)) return SIN_FILTRO;

        const productIds = new Set();
        const brandSlugs = new Set();

        productSearch.forEach(item => {
            if (!serviceableProductIds.has(String(item.id))) return;
            productIds.add(String(item.id));
            if (item.brand_slug) brandSlugs.add(item.brand_slug);
        });

        // Si el filtro dejaría los selects vacíos, es más útil no filtrar: casi
        // seguro el dato llegó mal antes que el catálogo no tenga nada.
        if (productIds.size === 0) return SIN_FILTRO;

        return { productIds, brandSlugs };
    }, [requires, serviceableProductIds, productSearch]);
}
